import { CLOSE_TOAST_DIALOG, FINISH_LOADING, OPEN_TOAST_DIALOG, START_LOADING } from "../actions/";

const progressReducer = (
  state = {
    isLoading: false,
    loadingList: [],
    isToastDialogOpen: false,
    toastDialogMessage: "",
    toastDialogType: null,
  },
  action
) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        isLoading: true,
        loadingList: [...new Set([...state.loadingList, action.execution])],
      };
    case FINISH_LOADING:
      const newList = state.loadingList.filter(
        (execution) => execution !== action.execution && execution !== undefined
      );

      return {
        ...state,
        isLoading: newList.length > 0 ? true : false,
        loadingList: [...newList],
      };
    case OPEN_TOAST_DIALOG:
      return {
        ...state,
        isToastDialogOpen: true,
        toastDialogMessage: action.toastDialogMessage,
        toastDialogType: action.toastDialogType,
      };
    case CLOSE_TOAST_DIALOG:
      return {
        ...state,
        isToastDialogOpen: false,
        toastDialogMessage: "",
      };
    default:
      return state;
  }
};

export default progressReducer;
